var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpArrowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2651",
    "data-name": "Group 2651",
    transform: "translate(-530 -391)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_833",
    "data-name": "Rectangle 833",
    width: 18,
    height: 18,
    transform: "translate(530 391)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "chevron-up",
    d: "M18,15,12,9,6,15",
    transform: "translate(527 388)",
    fill: "none",
    stroke: "#1450ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpArrowIcon);
export default __webpack_public_path__ + "static/media/up-arrow-icon.01fcbcb4c4fe22d3e3c952fca273798f.svg";
export { ForwardRef as ReactComponent };